import * as React from 'react';

import styled from 'styled-components';

import { testId } from '../test-utils/constants';

export function LoadingSpinner() {
	return (
		<SpinnerWrapper data-testid={testId('Loading_Spinner_Wrapper')}>
			<LoadingIconCircle data-testid={testId('Loading_Spinner')} />
		</SpinnerWrapper>
	);
}

const SpinnerWrapper = styled.div`
	grid-row: 1/-1;
	grid-column: 1/-1;

	margin: auto;
`;

interface CircleDimensionsProps {
	$loaderSize: number;
}

const ThinCircle = styled.div<CircleDimensionsProps>`
	position: absolute;
	height: ${props => props.$loaderSize}px;
	width: ${props => props.$loaderSize}px;
`;

const MovingHalfCircle = styled.div<CircleDimensionsProps>`
	position: relative;
	height: ${props => props.$loaderSize}px;
	width: ${props => props.$loaderSize}px;
	animation-name: circle_rotation;
	animation-iteration-count: infinite;
	animation-duration: 5s;
	@keyframes circle_rotation {
		100% {
			transform: rotate(360deg);
		}
	}
`;

export const LoadingIconCircle = ({ pickerLoad }: { pickerLoad?: boolean }) => {
	const loaderSize = pickerLoad ? 15 : 150;

	const movingHalfCircleConfig = pickerLoad
		? {
				viewBox: '0 0 18 18',
				pathD: 'M1 9C1 13.4183 4.58172 17 9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1',
				fill: 'none'
			}
		: {
				viewBox: '0 0 198 199',
				pathD: 'M180.1,45C162.5,19,132.7,2,99,2V0c34.9,0,65.6,17.9,83.5,45H180.1z',
				fill: '#ffffff'
			};

	return (
		<>
			{!pickerLoad && (
				<ThinCircle $loaderSize={loaderSize}>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 199">
						<circle fill="none" stroke="#FFFFFF" strokeWidth="2" strokeOpacity="0.2" cx="99" cy="100" r="99" />
					</svg>
				</ThinCircle>
			)}

			<MovingHalfCircle $loaderSize={loaderSize}>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox={movingHalfCircleConfig.viewBox} fill="none">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						fill={movingHalfCircleConfig.fill}
						d={movingHalfCircleConfig.pathD}
						stroke="#ffffff"
						strokeWidth="1"
					/>
				</svg>
			</MovingHalfCircle>
		</>
	);
};
